import React from 'react';
import { NameRenderer as BaseNameRenderer, MultipleOutsourceBadges } from '@ubeya/shared-web/components';
import styled from 'styled-components';
import { TIMESHEET_GROUP_BY_OPTIONS_ENUM } from '@ubeya/shared/constants';
import DateRenderer from './DateRenderer';
import EmployeeRatingRenderer from './EmployeeRatingRenderer';

const OutsourceBadgeWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  right: 2px;
  top: 50%;
  transform: translateY(-50%);
`;

const NameRenderer = (props) => {
  const {
    rowData: {
      isExternal,
      supplierData,
      originSupplierData,
      employee,
      rating,
      summarized,
      captainType = null,
      isThirdParty = false,
      shiftId,
      projectId
    },
    columnData: { groupBy, showCaptain = false, showRating = false, onClickEmployee } = {}
  } = props;
  if (summarized) {
    return null;
  }

  if (groupBy === TIMESHEET_GROUP_BY_OPTIONS_ENUM.EMPLOYEE) {
    return (
      <>
        <DateRenderer {...props} />
        {showRating && <EmployeeRatingRenderer rating={rating} />}
      </>
    );
  }

  const isExternalParams = {
    isExternal,
    clientProjectId: projectId,
    supplierShiftId: shiftId
  };

  const disableClick = isThirdParty;

  return (
    <BaseNameRenderer
      renderNext={
        isExternal ? (
          <OutsourceBadgeWrapper>
            <MultipleOutsourceBadges
              supplierData={supplierData}
              originSupplierData={originSupplierData}
              withName={false}
            />
          </OutsourceBadgeWrapper>
        ) : undefined
      }
      rowData={{ ...employee, rating, captainType }}
      columnData={{
        withUnderline: !disableClick,
        showCaptain,
        showRating,
        onClick: disableClick
          ? undefined
          : (e) => {
              e.stopPropagation();
              onClickEmployee?.({
                ...employee,
                ...(isExternal && isExternalParams)
              });
            }
      }}
    />
  );
};

export default NameRenderer;
